<app-header [userName]="userName" (logout)="logout()">
  <ng-container id="left-content">
    @if (defaultProduct && navLinks.length > 0) {
      <app-product-selection [defaultProduct]="defaultProduct" />
    }

    <nav class="flex items-center gap-3 ml-8">
      @for (link of navLinks; track link) {
        <a class="rounded px-4 py-2 text-neutral-700" routerLinkActive="bg-secondary-400 text-white" [routerLink]="link.url">
          {{ link.label }}
        </a>
      }
    </nav>
  </ng-container>
</app-header>

<main class="p-4">
  @if (!isLoading) {
    <router-outlet />
  }
</main>
